"use client";

import { useState } from "react";
import Link from "next/link";
import { Mail, Menu, Phone, X } from "lucide-react";
import { mainNav } from "@/config/navigation";
import { siteConfig } from "@/config/site";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { NavLink } from "./nav-link";

export function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <div className="lg:hidden">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-controls="mobile-menu"
        aria-label={open ? "Zavřít menu" : "Otevřít menu"}
        className="inline-flex size-11 items-center justify-center rounded-md border border-line bg-white text-brand-900 hover:bg-brand-50"
      >
        {open ? (
          <X aria-hidden="true" className="size-5" />
        ) : (
          <Menu aria-hidden="true" className="size-5" />
        )}
      </button>

      <div
        id="mobile-menu"
        hidden={!open}
        className="absolute inset-x-0 top-full border-b border-line bg-white shadow-lg"
      >
        <nav aria-label="Hlavní menu" className="container-page py-4">
          <ul className="flex flex-col">
            {mainNav.map((item) => (
              <li key={item.href}>
                <NavLink
                  href={item.href}
                  label={item.label}
                  onNavigate={() => setOpen(false)}
                  className="block px-2 py-3 text-base"
                />
              </li>
            ))}
          </ul>

          <div className="mt-4 flex flex-col gap-2 border-t border-line pt-4">
            <a
              href={`tel:${siteConfig.contact.phone}`}
              className={cn(buttonVariants({ variant: "primary" }), "w-full")}
              onClick={() => setOpen(false)}
            >
              <Phone aria-hidden="true" className="size-4" />
              {siteConfig.contact.phoneDisplay}
            </a>
            <a
              href={`mailto:${siteConfig.contact.email}`}
              className={cn(buttonVariants({ variant: "outline" }), "w-full")}
              onClick={() => setOpen(false)}
            >
              <Mail aria-hidden="true" className="size-4" />
              Napsat e-mail
            </a>
            <Link
              href="/kontakt"
              className={cn(buttonVariants({ variant: "ghost" }), "w-full")}
              onClick={() => setOpen(false)}
            >
              Domluvit konzultaci
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
}
